import mpRouter from "@/modules/management-panel/router";
import router from "@/modules/registration/router";
import Notifications from "@kyvg/vue3-notification";
import { createPinia } from "pinia";
import { createApp } from "vue";
import "vue-advanced-cropper/dist/style.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue3Storage, { StorageType } from "vue3-storage";
import Create from "./pages/Create.vue";
import EditBusiness from "./pages/EditBusiness.vue";
import ManagementPanelV2 from "./pages/ManagementPanelV2.vue";
import NewPassword from "./pages/NewPassword.vue";
import Profile from "./pages/Profile.vue";
import ProfileSavedNotification from "./pages/ProfileSavedNotification.vue";

const storageOptions = {
    namespace: "app_", storage: StorageType.Local,
};

const clickOutside = {
    beforeMount: (el, binding) => {
        el.clickOutsideEvent = (event) => {
            if (binding.arg !== undefined) {
                const ignoreThisElement = document.getElementById(binding.arg);
                if (ignoreThisElement === null) {
                    return;
                }
                // eslint-disable-next-line max-len
                if (
                    ignoreThisElement == event.target
                    || ignoreThisElement.contains(event.target)
                ) {
                    return;
                }
            }
            // here I check that click was outside the el and his children
            if (
                !(el == event.target || el.contains(event.target))
            ) {
                // and if it did, call method provided in attribute value
                if (binding.value instanceof Function) {
                    binding.value(event);
                }
            }
        };
        document.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted: (el) => {
        document.removeEventListener("click", el.clickOutsideEvent);
    },
};

if (document.querySelector("#create")) {
    const create = createApp(Create);

    create.use(Vue3Storage, storageOptions);
    create.use(Notifications);
    create.component("v-select", vSelect);
    create.use(router);
    create.directive("click-outside", clickOutside);

    create.use(createPinia());

    create.mount("#create");
}

if (document.querySelector("#profile")) {
    const profile = createApp(Profile);

    profile.component("v-select", vSelect);

    profile.mount("#profile");
}

if (document.querySelector("#edit-business")) {
    const edit = createApp(EditBusiness);

    edit.component("v-select", vSelect);

    edit.mount("#edit-business");
}

if (document.querySelector("#management-panel-new")) {
    const managementPanel = createApp(ManagementPanelV2);

    managementPanel.use(mpRouter);
    managementPanel.use(Notifications);
    managementPanel.component("v-select", vSelect);
    managementPanel.use(createPinia());

    managementPanel.directive("click-outside", clickOutside);
    managementPanel.mount("#management-panel-new");
}

if (document.querySelector("#mount-vue-toast-saved-profile")) {
    const toast = createApp(ProfileSavedNotification);
    toast.use(Notifications);
    toast.mount("#mount-vue-toast-saved-profile");
}

if (document.querySelector("#new-password")) {
    const newPassword = createApp(NewPassword);
    newPassword.mount("#new-password");
}
